__turbopack_context__.v({
  "modalContent": "NIMPDG_modalContent",
  "modalFooter": "NIMPDG_modalFooter",
  "modalHeader": "NIMPDG_modalHeader",
});
